
import { TicketRepository } from "@api/repositories/TicketRepository";
import { QueryBuilderInterface } from "@share/common/types/interfaces/api/QueryBuilerInterface";
import { ListLoaderInterface } from "@share/common/types/interfaces/list/ListLoaderInterface";

import Axios, { CancelTokenSource } from "axios";
import { TicketsListFilterState } from "@share/common/services/ticket/list/TicketsListFilterState";

export class TicketsListService<T> implements ListLoaderInterface<T> {
    constructor(
        private readonly queryBuilder: QueryBuilderInterface,
        private readonly ticketRepository: TicketRepository
    ) {

    }

    cancelToken?: CancelTokenSource;

    async load(filterState: TicketsListFilterState): Promise<T[]> {
        if (this.cancelToken) {
            this.cancelToken.cancel();
        }

        let query = this.queryBuilder.getQuery(filterState);

        this.cancelToken = Axios.CancelToken.source();

        const { tickets, count } = await this.ticketRepository.queryRawWithCount<T>(
            filterState.type,
            query,
            {
                cancelToken: this.cancelToken.token
            }
        );

        this.queryBuilder.setCount(count);

        return tickets;
    }
}